import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { REGISTRATION_ROUTES } from '../routes';

// local storage cache key
const FLOW_STORAGE_KEY = 'reg-flow';
const REG_ID_PARAM = 'regId';

// Flow codes
const FLOW_NEW_REGISTER = 'register';
const FLOW_INCOMPLETE_REG = 'incomplete';
const FLOW_MANAGE_REG = 'manage';
const FLOW_CANCEL_REG = 'cancel';
const FLOW_MANAGE_SCHOOL_DAY = 'manageSD';

/**
 * Analyze the current landing url (with regId if given) and validate it against the stored flow & regId
 * if they differ in any way - clean up the local storage cache before loading children
 */
const AppFlowAnalyzer: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { pathname, search } = useLocation();
    const regId = new URLSearchParams(search).get(REG_ID_PARAM);
    // keep the app from rendering while we are checking/cleaning the cache
    const [isReadyToContinue, setIsReadyToContinue] = useState(false);

    /** compare the current pathname with the flow routes */
    const getCurrentFlow = () => {
        switch (pathname) {
            case REGISTRATION_ROUTES.landing:
                return FLOW_NEW_REGISTER;
            case REGISTRATION_ROUTES.dashboard:
                return FLOW_INCOMPLETE_REG;
            case REGISTRATION_ROUTES.manageDashboard:
                return FLOW_MANAGE_REG;
            case REGISTRATION_ROUTES.cancelConfirmation:
                return FLOW_CANCEL_REG;
            case REGISTRATION_ROUTES.manageSchoolDayDashboard:
                return FLOW_MANAGE_SCHOOL_DAY;
            default:
                return '';
        }
    };

    /** concat flow w/ regId for the key value */
    const getCurrentFlowWithId = () => {
        return `${getCurrentFlow()}-${regId}`;
    };

    useEffect(() => {
        const currentFlow = getCurrentFlow();
        // if it is a landing page of any flow - check the regId if given
        if (currentFlow) {
            const oldFlow = sessionStorage.getItem(FLOW_STORAGE_KEY);
            const flowWithId = getCurrentFlowWithId();
            if (oldFlow !== flowWithId) {
                sessionStorage.clear();
                sessionStorage.setItem(FLOW_STORAGE_KEY, flowWithId);
                // eslint-disable-next-line no-console
                console.log('Wiping the session storage cache');
            }
        }

        setIsReadyToContinue(true);
    }, []);

    if (!isReadyToContinue) {
        return null;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};

export default AppFlowAnalyzer;
